import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { UserService } from 'src/app/data/user/user.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit {
  @HostBinding('class.full-width-container') classBinding = true;
  showBackButton = false;
  showLoginButton = true;

  constructor(private authService: AuthService, private userService: UserService) {}

  ngOnInit(): void {
    // Show back button only if the user is authorized.
    // There will be navigation if the user was initialized
    this.showBackButton = !!this.userService.loggedInUser;
  }

  login(): void {
    this.authService.dispose();
    window.location.href = '/';
  }

  back(): void {
    history.back();
  }
}
